var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"happy-at-sea"},[_c('h1',[_vm._v("Seafarers Happiness Index")]),_c('Nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }